export default "__VITE_ASSET__Cdyh6SAV__"